import type { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";

export interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "children" | "type"
> {
  label: ReactNode;
  onCheckedChange?: (checked: boolean) => void;
}

export function Checkbox({
  label,
  className,
  onChange,
  onCheckedChange,
  ...props
}: CheckboxProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
    onCheckedChange?.(event.target.checked);
  };
  return (
    <label className={["ui-checkbox", className].filter(Boolean).join(" ")}>
      <input {...props} type="checkbox" onChange={handleChange} />
      <span>{label}</span>
    </label>
  );
}
